module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAZlBMVEUAAAB7oTl7pz53ojx4pTx7pTl5ojx7pDt5ozl5ojt5ojp5ozp4pDp5ozp5ojp5ozp5ozp4ozl5pDt4ozp5ozp5ozp5ozt5ozp5ozl5ozp5ozl5ozp5ozp5ozp5ozp5ozp5ozr////TQG5FAAAAIHRSTlMAGx0eIjY3OFBSkp6fp6irtba7x8vM0dLV3d7h5PH4/Cl+m24AAAABYktHRCHEbA0WAAAAW0lEQVQY073NNw6AQBAEweY4vDeLh+P/ryRfkCCiw5JGAzD4WQxAnJsBwFTipn0VEZF1n5xUhvLUFXQ360hbXYpndd7j9ifb5vnQFkH/xRJrx9eP5mY14aJoCS6OSiQloW3EGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/menu/icn_calendar.png
// module id = ll3/
// module chunks = 1